<style scoped>
.svgContent {
  width: 100%;
  text-align: center;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);

  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);

  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  -webkit-perspective: 1000;
  perspective: 1000;

  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}
.svgTitle {
  position: fixed;
  width: 100%;
  top: 5px;
  z-index: 999;
  text-align: center;
}
.svgTitle h3 h4 {
  background-color: white;
}
.svgFooter {
  position: fixed;
  bottom: 0px;
  width: 100%;
}
</style>
<style>
.van-picker__columns {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  cursor: grab;
  bottom: 15px;
}
</style>

<template>
  <div>
    <div class="svgTitle">
      <h3>{{ orderBean.advertiserName }}-{{ orderBean.brandName }}</h3>
    </div>

    <div v-html="svgHtml" id="svgWorkPlatform" class="svgContent"></div>

    <van-row class="svgFooter">
      <van-col span="24">
        <van-button
          size="large"
          type="default"
          icon="todo-list-o"
          @click="showSchedules = true"
        >
          {{ chooseSchedule.startDate }} - {{ chooseSchedule.endDate }}
        </van-button>
      </van-col>
    </van-row>

    <van-popup
      v-model="showSchedules"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        title="请选择投放档期"
        show-toolbar
        :default-index="defalutChooseSchedule"
        :columns="scheduleColumns"
        @confirm="handleChooseSchedule"
        @cancel="showSchedules = false"
      />
    </van-popup>

    <van-popup v-model="showStationSvg" position="right"  :style="{ height: '98%', width:'85%' }">
        <stationSvg ref="stationSvg" :orderId="orderBean.id" @showDevicePublishInfo="showDevicePublishInfo"/>
    </van-popup>

    <van-popup v-model="showDemand" position="right"  :style="{ height: '98%', width:'85%' }">
      <demand ref="deviceDemand"/>
    </van-popup>
  </div>
</template>

<script>
import '@vant/touch-emulator' // 用于解决web端模拟移动端的触摸事件
import stationSvg from './stationSvg'
import demand from './demand'

import { Button, Col, Row, Popup, Picker, Cell, Toast, Icon, Dialog } from 'vant'
import { mapOperation } from '@/utils/mapOperation'
import { getOrder, getOrderResourceCount, getCompanyCityCode } from '@/api/order'

export default {
  mixins: [mapOperation], // 混入地图操作的方法
  components: {
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    stationSvg,
    demand
  },
  data () {
    return {
      chooseCity: '',
      spinShow: false,
      svgHtml: '',

      orderCode: this.$route.params.id,
      orderBean: {}, // 订单实体
      stationList: [],
      chooseSchedule: {
        startDate: '',
        endDate: ''
      },
      showSchedules: false,
      defalutChooseSchedule: 0,
      scheduleColumns: [],
      showStationSvg: false,
      showDemand: false
    }
  },
  mounted () {
    this.initPageData()
    // 设置中间区域地图高度
    this.$nextTick(() => {
      document.getElementById('svgWorkPlatform').style.height =
        document.documentElement.clientHeight + 'px'
    })
  },
  methods: {
    initPageData () {
      if (this.orderCode) {
        let postData = { code: this.orderCode }

        getOrder(postData).then((res) => {
          // 获取订单所在的城市CODE
          getCompanyCityCode({ companyId: res.publisherId }).then((city) => {
            this.chooseCity = city
            this.initMap(null, 5)
          })

          this.orderBean = res
          this.chooseSchedule = res.purchasedScheduleList[0]
          this.defalutChooseSchedule = 0
          this.scheduleColumns = res.purchasedScheduleList.map(
            (x) => x.startDate + ' - ' + x.endDate
          )
        })
      }
    },
    loadOrderStationsData () {
      let postData = {
        code: this.orderCode,
        schedules: JSON.stringify([this.chooseSchedule])
      }

      getOrderResourceCount(postData).then((res) => {
        this.stationList = res
        // 从外部组件从显示出点位
        this.loadResourceStations(res, res[0].stationId.toString(), false)
      })
    },
    handleClickStation (stationId) {
      this.showStationSvg = true
      // 从外部组件从显示出点位
      setTimeout(() => {
        this.$refs.stationSvg.initDemandData(stationId, this.chooseSchedule)
      }, 500)
    },
    handleChooseSchedule (val, index) {
      this.showSchedules = false
      this.chooseSchedule = this.orderBean.purchasedScheduleList[index]
      this.loadOrderStationsData()
    },
    showDevicePublishInfo (infoBean) {
      this.showDemand = true
      setTimeout(() => {
        this.$refs.deviceDemand.initDemandData(infoBean)
      }, 500)
    }
  },
  watch: {
    spinShow (val) {
      if (val) {
        Toast.loading({
          message: '地图加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0
        })
      } else {
        Toast.clear()
        // 地图载入完毕，开始执行标注信息
        this.loadOrderStationsData()
      }
    }
  }
}
</script>
